import { render, staticRenderFns } from "./ProductSetUpsertModal.vue?vue&type=template&id=2fda4c7f"
import script from "./ProductSetUpsertModal.vue?vue&type=script&lang=ts"
export * from "./ProductSetUpsertModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports